import {
	FrontendSample,
	FrontendSampleSpecification,
	FrontendClient,
	FrontendCompanyWithAdditionalInfomation,
	FrontendOrder,
	FrontendOrganization,
	FrontendOrganizationLicense,
	FrontendUserInfo,
	FrontendCompanyTestCategory,
	FrontendSampleSpecificationDirectory,
} from "node-library/dist/portal";
import { useState } from "react";
import { CustomTextInput } from "../../common-components/inputs";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "../../common-components/toast/showToastMessage";
import { GreenButton } from "../../common-components/button";
import { ButtonTextLoadingAnimation } from "../../common-components/animation/ButtonLoadingAnimation";
import { Severity } from "node-library/dist/constants";
import { RedErrorIcon } from "../../common-components/toast/errorIcons";
import { sendGETRequest } from "../../requestHelper/sendRequest";
import { OrderDetailsAPIExport } from "node-library/dist/apiDataFormats";
import { GreenTickIcon } from "../../common-components/toast/successIcons";
import CPDetailsOrgAndUserComponent from "./cp-details-components/cpDetailsOrgAndUserComponent";
import { constructFrontendOrderFromExportData } from "../../helpers/barcodeHelper";
import NewOrEditOrder from "../mainPages/newOrEditOrderPage";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	setCompany: React.Dispatch<
		React.SetStateAction<FrontendCompanyWithAdditionalInfomation | undefined>
	>;
	cannabisTestCategory: FrontendCompanyTestCategory;
	user: FrontendUserInfo | undefined;
	orderInfo: OrderDetailsAPIExport;
	associatedOrg: FrontendOrganization;
	setAssociatedOrg: React.Dispatch<
		React.SetStateAction<FrontendOrganization | undefined>
	>;

	associatedOrgClients: Array<FrontendClient>;
	orderSelectedClient: FrontendClient | undefined;
	setOrderSelectedClient: React.Dispatch<
		React.SetStateAction<FrontendClient | undefined>
	>;
	associatedOrgLicenses: Array<FrontendOrganizationLicense>;
	setAssociatedOrgLicenses: React.Dispatch<
		React.SetStateAction<Array<FrontendOrganizationLicense>>
	>;
	associatedOrgSamples: Array<FrontendSample>;
	setAssociatedOrgSamples: React.Dispatch<
		React.SetStateAction<Array<FrontendSample>>
	>;
	orderSelectedLicense: FrontendOrganizationLicense | undefined;
	setOrderSelectedLicense: React.Dispatch<
		React.SetStateAction<FrontendOrganizationLicense | undefined>
	>;
	organizationSpecifications: Array<FrontendSampleSpecification>;
	setOrganizationSpecifications: React.Dispatch<
		React.SetStateAction<Array<FrontendSampleSpecification>>
	>;
	organizationSpecDirectories: Array<FrontendSampleSpecificationDirectory>;

	setUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
	gotoViewOrderPage: () => void;
}

export default function ClientPortalOrderDetailsContent(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const {
		user,
		orderInfo,
		associatedOrg,
		setAssociatedOrg,
		associatedOrgClients,
		orderSelectedClient,
		setOrderSelectedClient,
		associatedOrgLicenses,
		setAssociatedOrgLicenses,
		associatedOrgSamples,
		setAssociatedOrgSamples,
		orderSelectedLicense,
		setOrderSelectedLicense,
		organizationSpecifications,
		setOrganizationSpecifications,
		organizationSpecDirectories,
		cannabisTestCategory,
	} = props;

	const [currentPage, setCurrentPage] = useState<number>(0);

	const [constructedFrontendOrder, setConstructedFrontendOrder] = useState<
		FrontendOrder | undefined
	>();
	//validations

	function goToOrderDetailsPage(
		client: FrontendClient,
		license: FrontendOrganizationLicense | undefined,
	) {
		const { newSamples, order } = constructFrontendOrderFromExportData(
			orderInfo.orderInfo.barcodeId,
			associatedOrg,
			client,
			license,
			associatedOrgSamples,
			organizationSpecifications,
			orderInfo,
			cannabisTestCategory,
		);

		setAssociatedOrgSamples((prevSamples) => [...prevSamples, ...newSamples]);
		setConstructedFrontendOrder(order);
		setCurrentPage(1);
	}

	let detailsContent: React.ReactNode;

	switch (currentPage) {
		case 0:
			detailsContent = (
				<CPDetailsOrgAndUserComponent
					testCategory={cannabisTestCategory}
					user={user}
					orderInfo={orderInfo}
					associatedOrg={associatedOrg}
					setAssociatedOrg={setAssociatedOrg}
					associatedOrgClients={associatedOrgClients}
					setOrderSelectedClient={setOrderSelectedClient}
					associatedOrgLicenses={associatedOrgLicenses}
					setAssociatedOrgLicenses={setAssociatedOrgLicenses}
					setOrderSelectedLicense={setOrderSelectedLicense}
					setConstructedFrontendOrder={setConstructedFrontendOrder}
					gotoNextPage={goToOrderDetailsPage}
				></CPDetailsOrgAndUserComponent>
			);
			break;
		case 1:
			detailsContent = (
				<NewOrEditOrder
					company={props.company}
					setCompany={props.setCompany}
					orderTestCategory={cannabisTestCategory}
					user={props.user}
					client={orderSelectedClient as FrontendClient}
					selectedOrganization={associatedOrg}
					clientLicenses={associatedOrgLicenses}
					gotoViewOrderPage={props.gotoViewOrderPage}
					order={constructedFrontendOrder as FrontendOrder}
					organizationSamples={associatedOrgSamples}
					setUnsavedChanges={props.setUnsavedChanges}
					goBackToPreviousPage={() => {
						setCurrentPage(0);
					}}
					organizationSpecifications={organizationSpecifications}
					orgInfoLoaded={true}
					isRegisteringFromClientPortal
					organizationSpecDirectories={organizationSpecDirectories}
				></NewOrEditOrder>
			);
			break;
	}

	return <>{detailsContent}</>;
}
